import utils from "../../scripts/utils";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      projectRoute: [],
      menuRoute: [],
      menuProp: {
        path: "routeAddress",
        icon: "icon",
        name: "name",
        children: "childList",
      },
    };
  },

  watch: {
    $route(to) {
      this.setInfo(to);
    },
  },
  computed: {
    ...mapGetters(["menuList"]),
  },
  created() {
    this.projectRoute = this.$router.options.routes;
    this.setInfo(this.$route);
  },
  methods: {
    /**获取面包屑数据 */
    setInfo(route) {
      let menuList = JSON.parse(JSON.stringify(this.menuList));
      this.menuRoute = [];
      let menuInfo = [];
      let pathArray = [];
      let path = null;
      // let catalogName="";
      path = route.path.match(/\/\w+/g) || [];
      path.forEach((val, index) => {
        pathArray.push(index === 0 ? val : pathArray[index - 1] + val);
      });
      menuInfo = route.matched;
      // menuInfo.shift();
      let defaultInfo = this.new_filter(menuList, menuInfo);
      //flag 判断当前路由是否存在于左侧菜单数据中
      let flag = false;
      defaultInfo.forEach((el) => {
        if (el.path == route.path) {
          flag = true;
        }
      });
      if (!flag) {
        let new_arr = [];
        let replaceStr = pathArray[0] + "/";
        pathArray.forEach((el, index) => {
          let data = {};
          if (index === 0) {
            data = el;
          } else {
            data = el.replace(replaceStr, "");
          }
          new_arr.push(data);
        });
        let new_pathArr = new_arr.filter(
          (item) =>
            !this.menuRoute.some(
              (defaultItem) => defaultItem[this.menuProp.path] == item
            )
        );
        let projectRoute = [];
        let hasRouteFlag = false;
        this.projectRoute.forEach((el) => {
          if (el.path == new_pathArr[0]) {
            hasRouteFlag = true;
            projectRoute.push(el);
          }
        });
        if (!hasRouteFlag) {
          projectRoute = this.projectRoute;
        }
        this.breadcrumbSet(projectRoute, new_pathArr);
        // this.breadcrumbSet(this.projectRoute, new_pathArr);
      }
      //   if (this.activePath != this.$route.path) {
      //     this.activedMenu(menuList, pathArray);
      //   }
    },
    /**
     * 左侧菜单栏当前选中的菜单
     * @param routes 当前项目中所有路由，为树形结构
     * @param pathArray 当前路由根据/分割出来后重组的数组
     */
    breadcrumbSet(routes, pathArray) {
      routes.filter((item) => {
        if (
          (pathArray.includes(item.path) ||
            pathArray.includes(item.new_path)) &&
          item.meta &&
          item.meta.title
        ) {
          // let path =this.fromPath.path==path?this.fromPath.fullPath:item.path;
          let data = {
            icon: null,
            path: item.new_path ? item.new_path : item.path,
            name: item.meta.title,
            type: 1,
          };
          this.menuRoute.push(data);
          this.menuRoute = utils.unique(this.menuRoute, "path");
        }
        if (item.children && item.children.length > 0) {
          this.breadcrumbSet(item.children, pathArray);
        }
      });
    },
    /**
     * @param menu 用户菜单列表，即左侧菜单栏数据
     * @param arr 当前路由的matched
     */
    new_filter(menu, arr) {
      menu.filter((menuItem) => {
        arr.filter((item) => {
          let routeFlag = item.regex.test(menuItem[this.menuProp.path]);
          if (menuItem[this.menuProp.path] == item.path || routeFlag) {
            this.activePath = menuItem[this.menuProp.path];
            let data = {
              icon: menuItem[this.menuProp.icon]
                ? menuItem[this.menuProp.icon]
                : null,
              path: menuItem[this.menuProp.path],
              name: menuItem[this.menuProp.name],
              //type菜单类型，0：目录；1：菜单
              type: menuItem.type != undefined ? menuItem.type : 1,
            };
            this.menuRoute.push(data);
            this.menuRoute = utils.unique(this.menuRoute, "path");
          }
        });
        if (
          menuItem[this.menuProp.children] &&
          menuItem[this.menuProp.children].length > 0
        ) {
          this.new_filter(menuItem[this.menuProp.children], arr);
        }
      });
      return this.menuRoute;
    },
  },
};
